module.exports = __webpack_public_path__ + "img/Bruschetta_thumbnail.8820315d.webp";